import * as moment from 'moment';

type RelativeTimeKey = 's' | 'ss' | 'm' | 'mm' | 'h' | 'hh' | 'd' | 'dd' | 'M' | 'MM' | 'y' | 'yy';

type RelativeTimeSpecVal = (
  string |
  ((n: number, withoutSuffix: boolean,
    key: RelativeTimeKey, isFuture: boolean) => string)
);

export const updateLocale = (locale: string) => {
  let updateLocaleConfig = {};

  if (locale === 'ko') {
    updateLocaleConfig = koLocaleConfig;
  }
  if (locale === 'en') {
    updateLocaleConfig = enLocaleConfig;
  }
  moment.updateLocale(locale, updateLocaleConfig);
}

const koLocaleConfig = {
  relativeTime: {
    future: '%s 후',
    past: '%s 전',
    s: '%d초',
    ss: '%d초',
    m: '%d분',
    mm: '%d분',
    hh: '%d시간',
    d: '%d일',
    dd: '%d일',
    M: '%d달',
    MM: '%d달',
    y: '%d년',
    yy: '%d년'
  }
};

const enLocaleConfig = {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
}



// WEBPACK FOOTER //
// ./src/modules/moment.ts